import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/lab';

import Select from 'react-select';

import {api} from '../../actions/_request';


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



class LabModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            impuesto: {
                id:0,               
                nombre:'',
                tipo:1,
                porcentaje:0,
                comentario:'',                
            },
            action: 'save',
            activeTab: '1',
            modal:false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
                 
    }
   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

    componentDidMount()
    {
         
        let prospectoid = this.props.prospectoid;
        let self = this;
              
        if(prospectoid > 0 && prospectoid != self.state.impuesto.id)
        {

            api().get(`lab/${prospectoid}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        impuesto: response.data,
                        action: 'update'
                    });

                }

            });
        }
        else if(prospectoid == null && self.state.impuesto.id)
        {            
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
            impuesto: {
                id:0,               
                nombre:'',
                tipo:1,
                porcentaje:0,
                comentario:'',                
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    



    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        impuesto[name] = value;
     
        this.setState({
            impuesto : impuesto
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {impuesto} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;        
        
            let check = ['nombre'];

            for(let i in check) {

            let key = check[i];

            let value = impuesto[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }       
             
           
              
        impuesto=this.objeto_mayusculas(impuesto);
        console.log('impuesto modificado---->',impuesto)

        if(save){
                  this.props[action](impuesto, (data) => {
                    swal({
                        title: 'Concepto Lab',
                        text: 'Concepto Lab Guardado correctamente!',
                        type: 'success',
                        // showCancelButton: true,
                        // confirmButtonColor: '#3085d6',
                        // cancelButtonColor: '#d33',
                        confirmButtonText: 'Continue!'
                    }).then((result) => {
                        if (result.value) {
                          
                           
                           
                            this.props.toggle();
                            this.resetModal();
                        }
                    })
                });

           


         

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render()
    {

        let {impuesto}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Datos
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => { this.toggle_tab('2'); }}
                        >
                         Nota
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Codigo</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="id"
                                    value={impuesto.id} readOnly  />
                            </FormGroup>
                        </div>                        
                        </div>
                         <div className="row mt-3 form_cliente">       
                        <div className="col-md-12">
                            <FormGroup>
                                <Label>Nombre</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="nombre"
                                    value={impuesto.nombre}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label>Porcentaje</Label>
                                    <Input
                                    placeholder=""
                                    type="number"
                                    name="porcentaje"
                                    value={impuesto.porcentaje}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                                         
                    </div>
                           
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col sm="12">
                          <div className="row mt-3 form_cliente">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Nota</label>
                                    <Input
                                      rows={10}                                                        
                                      type="textarea"
                                      name="comentario"
                                      value={impuesto.comentario} 
                                      maxLength={249}
                                      onChange={ this.handleInputChange}
                                      />
                                    
                                </div>
                            </div>                                   
                                                      
                        </div>                          
                          </Col>
                        </Row>
                      </TabPane>                      
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.lab.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        lab : state.lab,
    }
};

export default connect(mapStateToProps, actions)(LabModal)


// WEBPACK FOOTER //
// ./src/views/lab/Modal.js